module.exports = __webpack_public_path__ + "static/img/close.b6e04ec5.png";